I/* LaMavi Gratis-Stirnband */
(() => {
  const MASK_ID = 49229952483667;
  const GIFT_ID = 49834115957075;

  let syncing = false;

  async function syncGift() {
    if (syncing) return;
    syncing = true;

    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();

      const hasMask = cart.items.some(
        item => Number(item.variant_id) === MASK_ID
      );

      const gift = cart.items.find(
        item =>
          Number(item.variant_id) === GIFT_ID &&
          item.properties &&
          item.properties._lamavi_gift === 'yes'
      );

      // Maske im Warenkorb → Stirnband hinzufügen
      if (hasMask && !gift) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: GIFT_ID,
              quantity: 1,
              properties: {
                _lamavi_gift: 'yes'
              }
            }]
          })
        });
      }

      // Maske entfernt → Gratis-Stirnband entfernen
      if (!hasMask && gift) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: gift.key,
            quantity: 0
          })
        });
      }
    } catch (error) {
      console.error('LaMavi Gift Error:', error);
    } finally {
      syncing = false;
    }
  }

  // Beim Laden prüfen
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(syncGift, 500);
  });

  // Nach Hinzufügen / Entfernen / Mengenänderung erneut prüfen
  document.addEventListener(
    'submit',
    () => setTimeout(syncGift, 1000),
    true
  );

  document.addEventListener(
    'click',
    () => setTimeout(syncGift, 1000),
    true
  );
})();